import React, { useEffect } from "react";
import "./index.scss";
import "@assets/stylesheets/inc/_table.scss";
import MainPage from "./subpages/MainPage";
import { useHistory } from "react-router-dom";
import { useAppSelector } from "@redux/hooks";

import UpcomingShipments from "./UpcomingShipments";

function DashboardPage() {
    return (
        <div className="flex flex-column content-between gap-[24px]">
            <UpcomingShipments />
            <MainPage />
        </div>
    );
}

export default DashboardPage;
